import React, {Button, Component, useState } from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import _ from '../../utils/languages/languages';
import TextInput from "../../widgets/TextInput";
import FixButton from "../../widgets/Button";
//import TimePicker from 'react-time-picker';
import ManageCompany from '../../services/manageCompany';
import GetCompany from '../../services/getCompany';
import ImageInput from "../../widgets/ImageInput";
import SelectInput from "../../widgets/SelectInput";
import getIntermediaries from "../../services/getIntermediaries";
import Utils from '../../utils/utils';

export default class EditCompany extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };
  
    this.section = this.props.section
    if (this.section == undefined){
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.userslist = [];

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: false,
      addElementVisible: false
    }

    this.grid = 2;

    this.pageTitle = "Edit Company";
    this.startDateRef = React.createRef();
    this.endDateRef = React.createRef();

    this.state = {

    };

  }


  async componentDidMount(){

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    const currentEventId = cookies.get('currentEventId', { path: '/' });
    const currentCompany = cookies.get('currentCompany', { path: '/' });

    this.company = await GetCompany(username, token, currentEventId, currentCompany);
    this.brokers = await getIntermediaries(username, token, currentEventId, 'company');

    this.brokerSelect = [];
    this.brokerSelected = [];
    this.brokers && this.brokers.forEach(b => {
      this.brokerSelect.push({ value: b.id, label: b.name });
      var brokersArray = this.company.broker_id.split(',');
      if (brokersArray.includes(b.id))
        this.brokerSelected.push ({ value: b.id, label: b.name });

      this.setState({
        brokers: this.brokerSelected
      })
    })

    this.setState({
      companyName: this.company.name,
      website: this.company.web_site,
      marketCap: this.company.market_cap,
      bloombergNumber: this.company.bloombergNumber,
      logo: this.company.logo,
      logo_simple: this.company.logo_simple,
      sector: this.company.sector,
      country: this.company.country,
      pdfProfile: this.company.pdf_profile,
      rapresentative: this.company.rapresentative,
      contactPerson: this.company.contact_person,
      phoneNumber: this.company.phone_number,
      mobileNumber: this.company.mobile_number,
      email: this.company.email_address,
      additionalMailAddress: this.company.second_email_address,
      moreEmails: this.company.more_emails
    });
  }

  render () {

    return (
      <>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={_.tr('Loading your content...')}
      >
        <PageTitle title={this.pageTitle} />
          
          <TextInput name={'Company name'} value={this.state.companyName} 
            onChange={(text) => { this.setState({companyName: text})}
          } />
          
          <SelectInput key={Math.random()} 
                    ref={this.selectRef}
                    value={this.state.brokers} 
                    name={"Brokers"} 
                    options={this.brokerSelect} 
                    isMulti={true}
                    onChange={(option) => {
                        this.setState({brokers: option});
                        var strBrokers = "";
                        option != null && option.forEach(opt => {
                          if (strBrokers.length > 0) strBrokers += ",";
                          strBrokers += opt.value;
                        });
                        this.company.broker_id = strBrokers;
                      }}
                    />

          <ImageInput name={'Logo'} key={Math.random()} 
            value={this.state.logo}
            onChange={(val) =>           
              this.setState({logo: val})
              }
          />

          <ImageInput name={'Schedule\'s banner'} key={Math.random()} 
            value={this.state.logo_simple}
            onChange={(val) =>           
              this.setState({logo_simple: val})
              }
          />

          <TextInput name={'Website'} value={this.state.website} 
            onChange={(text) => { this.setState({website: text})}
          } />
          <TextInput name={'Market Cap'} value={this.state.marketCap} 
            onChange={(text) => { this.setState({marketCap: text})}
          } />
          <TextInput name={'Bloomberg number'} value={this.state.bloombergNumber} 
            onChange={(text) => { this.setState({bloombergNumber: text})}
          } />
          <TextInput name={'Sector'} value={this.state.sector} 
            onChange={(text) => { this.setState({sector: text})}
          } />
          <TextInput name={'Country'} value={this.state.country} 
            onChange={(text) => { this.setState({country: text})}
          } />
          <TextInput name={'Pdf Profile'} value={this.state.pdfProfile} 
            onChange={(text) => { this.setState({pdfProfile: text})}
          } />
          <TextInput name={'Representatives (separated by ;)'} value={this.state.rapresentative} 
            onChange={(text) => { this.setState({rapresentative: text})}
          } />
          <TextInput name={'Contact Person'} value={this.state.contactPerson} 
            onChange={(text) => { this.setState({contactPerson: text})}
          } />
          <TextInput name={'Phone Number'} value={this.state.phoneNumber} 
            onChange={(text) => { this.setState({phoneNumber: text})}
          } />
          <TextInput name={'Mobile Number'} value={this.state.mobileNumber} 
            onChange={(text) => { this.setState({mobileNumber: text})}
          } />
          <TextInput name={'eMail Address'} value={this.state.email} 
            onChange={(text) => { this.setState({email: text})}
          } />
          <TextInput name={'Additional eMail address'} value={this.state.additionalMailAddress} 
            onChange={(text) => { this.setState({additionalMailAddress: text})}
          } />
          <TextInput name={'Other e-mail addresses (separated by ;)'} value={this.state.moreEmails} 
            onChange={(text) => { this.setState({moreEmails: text})}
          } />

          <FixButton title={'Save'} callback={this.save.bind(this)} />

        </LoadingOverlay>
      </>
    );
  }

  async save (){
      const cookies = new Cookies();
      const username = cookies.get('username', { path: '/' });
      const token = cookies.get('token', { path: '/' });
      const currentCompany = cookies.get('currentCompany', { path: '/' });
      const currentEventId = cookies.get('currentEventId', { path: '/' });

      if (this.company.broker_id == ''){
        alert('You have to select at least a broker');
        return;
      }

      if (this.state.email != undefined && this.state.email != '' && Utils.validateEmail(this.state.email) == false){
        alert('Check the email address');
        return;
      }

      if (this.state.additionalMailAddress != undefined && this.state.additionalMailAddress != '' && Utils.validateEmail(this.state.additionalMailAddress) == false){
        alert('Check the additional email address');
        return;
      }

      let ret = await ManageCompany(username, token, currentCompany, currentEventId, 
        this.company.broker_id, this.state.companyName, this.state.logo_simple, 
        this.state.logo, this.state.marketCap, this.state.sector, this.state.pdfProfile,
        this.state.website, this.state.rapresentative, this.state.contactPerson,
        this.state.phoneNumber, this.state.mobileNumber, this.state.email, 
        this.state.additionalMailAddress, this.state.moreEmails, this.state.bloombergNumber, this.state.country, false);

      if (ret.result == 'ok'){
        alert ('Saved successfully');
      }
      else {
        alert ('An error happened');
      }
     
  }

}

